import React from 'react';
import useSheet from 'app/jss';
import Icon from 'app/components/commons/Icon';
import CardContentMessage from 'app/components/friends/friendCard/CardContentMessage';
import t from 'app/utils/translate';

type Props = {
  classes: Object,
};

function GroupListNoGroups({
  classes,
}: Props) {
  return (
    <div className={classes.noGroups}>
      <CardContentMessage
        title={t('You have no groups')}
        subText={t('You can create new groups to categorise your friends and add/remove them here.')}
      />
      <div className={classes.watermark}>
        <Icon type="icon-group" />
      </div>
    </div>
  );
}

function applyStyles(theme: Theme) {
  return {
    noGroups: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      position: 'relative',
      overflow: 'hidden',
    },
    watermark: {
      position: 'absolute',
      boxSizing: 'content-box',
      color: theme.color.basis2,
      border: `0.5em solid ${theme.color.basis2}`,
      fontSize: '2rem',
      borderRadius: '100%',
      padding: '0.5em',
      transform: 'translate3d(calc(-50% + 0.6em), calc(50% - 0.45em), 0)',
      left: 0,
      bottom: 0,
      opacity: 0.1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  };
}

export default useSheet(applyStyles)(GroupListNoGroups);
